import React from 'react';
import {Outlet} from 'react-router-dom';

const screenStyle: React.CSSProperties = {
    minHeight: '100vh',
    width: '100%',
    position: 'relative',
    backgroundColor: 'var(--tt-bg)',
    backgroundImage: `
        radial-gradient(circle, color-mix(in srgb, var(--tt-border) 80%, transparent) 1.1px, transparent 1.1px),
        linear-gradient(color-mix(in srgb, var(--tt-border) 60%, transparent) 1px, transparent 1px),
        linear-gradient(90deg, color-mix(in srgb, var(--tt-border) 60%, transparent) 1px, transparent 1px)
    `,
    backgroundSize: '24px 24px, 144px 144px, 144px 144px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 0',
    overflowY: 'auto',
    fontFamily: '\'Plus Jakarta Sans\', -apple-system, BlinkMacSystemFont, sans-serif'
};

const topbarStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 6,
    zIndex: 2,
    // Fixed brand teal in both themes (matches the badge + mockup); --tt-logo-fill
    // inverts to white in dark mode.
    backgroundColor: '#113139'
};

const edgeFadeStyle: React.CSSProperties = {
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    background: 'radial-gradient(ellipse at center, transparent 35%, var(--tt-bg) 80%)',
    zIndex: 0
};

const cardStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: 416,
    padding: '0 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    position: 'relative',
    zIndex: 1
};

export function AuthShell({children}: { children: React.ReactNode }) {
    return (
        <div className="shade-control-panel auth-shell" style={screenStyle}>
            <div style={topbarStyle} />
            <div aria-hidden="true" style={edgeFadeStyle} />
            <div className="auth-card" style={cardStyle}>
                {children}
            </div>
        </div>
    );
}

export function AuthLayout() {
    return (
        <AuthShell>
            <Outlet />
        </AuthShell>
    );
}
